export const COOKIE_POLICY_ROUTE = "cookie_policy";
export const LOGIN_ROUTE = "login";
export const FILESTREAM_ROUTE = "filestream";
export const REPORT_ROUTE = "report";
export const REPORTS_ROUTE = "reports";
export const PROJECTS_ROUTE = "projects";
export const PROJECT_ROUTE = "project";
export const PACKAGE_ROUTE = "package";
export const PACKAGE_ABOUT_ROUTE = "about";
export const PACKAGE_VERSIONS_ROUTE = "versions";
export const INSIGHTS_ROUTE = "insights";
export const INSIGHTS_SEARCH_ROUTE = "search";
export const MEMBERS_ROUTE = "members";
export const GROUPS_ROUTE = "groups";
export const SETTINGS_ROUTE = "settings";
export const LICENSING_ROUTE = "licensing";
export const CLI_CAPACITY_ROUTE = "cli-capacity";
export const POLICY_CONFIG_ROUTE = "policies";
export const SOFTWARE_CATALOG_ROUTE = "software-catalog";
export const CATALOG_ROUTE = "catalog";
export const SOFTWARE_CATALOG_PLATFORM_ROUTE = "platform";
export const SOFTWARE_CATALOG_ARCHITECTURE_PARAM = "architecture";
export const SOFTWARE_CATALOG_EXTENSION_PARAM = "extension";
export const SOFTWARE_CATALOG_NO_EXTENSION = "none";
export const ORGANIZATION_CATALOG_ID = "organization";
export const HELP_ROUTE = "help";
export const REQUEST_PASSWORD_RESET_ROUTE = "request_password_reset";
export const PASSWORD_RESET_ROUTE = "password_reset";
export const EMAIL_CONFIRMATION_ROUTE = "email_confirmation";
export const ACCEPT_INVITE_ROUTE = "users/invite";
export const REGISTER_USER_ROUTE = "users/register";
export const USER_DIRECTORY_ROUTE = "user-directory";
export const GROUP_MAPPING_ROUTE = "group-mapping";
export const VERIFY_SSO_CHANGES_ROUTE = "verify-sso-changes";
export const VERIFY_SSO_LOGIN_ROUTE = "sso-verification";
export const SHAREABLE_REPORTS_ROUTE = "shareable-reports";
export const SESSION_CONFIGURATION_ROUTE = "session-configuration";
export const AI_CONFIGURATION_ROUTE = "ai-configuration";
export const AUDIT_ROUTE = "audit";

export const USER_SETTINGS_ROUTE = "profile";
export const PROFILE_ROUTE = "details";
export const CHANGE_PASSWORD_ROUTE = "change-password";
export const PERSONAL_ACCESS_TOKEN_ROUTE = "personal-access-tokens";
export const APPEARANCE_ROUTE = "appearance";

export const PAGE_NOT_FOUND_ROUTE = "page-not-found";
export const SHARED_REPORT_NOT_FOUND_ROUTE = "report-not-found";

export const FORBIDDEN_ROUTE = "forbidden";

export const FULL_INSIGHTS_PATH = `${INSIGHTS_ROUTE}/group/:groupId/${INSIGHTS_SEARCH_ROUTE}/:searchId`;
export const FULL_REPORT_PATH = `${REPORTS_ROUTE}/group/:groupId/${REPORT_ROUTE}/:projectName/:packageName/:version`;
export const FULL_MEMBERS_PATH = `organization/:organizationId/${MEMBERS_ROUTE}`;
export const FULL_GROUPS_PATH = `organization/:organizationId/${MEMBERS_ROUTE}/${GROUPS_ROUTE}`;
export const FULL_SINGLE_GROUP_PATH = `organization/:organizationId/${MEMBERS_ROUTE}/${GROUPS_ROUTE}/:membersGroupId`;
export const FULL_ORGANIZATION_POLICIES_PATH =
  "organization/:organizationId/policies";
export const FULL_GROUP_POLICIES_PATH = "policies/group/:groupId";
export const FULL_LICENSING_PATH = "organization/:organizationId/licensing";

export const SHAREABLE_REPORT_ROOT_PATH = `${SHAREABLE_REPORTS_ROUTE}/:token`;
export const SHAREABLE_REPORT_PATH = `${SHAREABLE_REPORT_ROOT_PATH}/:reportPage?`;

// For backwards compatibility purposes
export const OLD_REPORT_PATH = `${REPORTS_ROUTE}/group/:groupId/${REPORT_ROUTE}/:reportId?/:reportPage?`;
export const OLD_DIFF_REPORT_PATH = `${FULL_REPORT_PATH}/diff`;
export const OLD_MEMBERS_PATH = `/${MEMBERS_ROUTE}`;
export const OLD_GROUPS_PATH = `/${MEMBERS_ROUTE}/${GROUPS_ROUTE}`;
export const OLD_SINGLE_GROUP_PATH = `/${MEMBERS_ROUTE}/${GROUPS_ROUTE}/:membersGroupId`;
export const OLD_ORGANIZATION_CONFIGURATION_PATH =
  "/settings/configuration/organization/:organizationId";
export const OLD_GROUP_CONFIGURATION_PATH =
  "/settings/configuration/group/:groupId";
export const OLD_LICENSING_PATH = "/settings/licensing";
